import { Injectable, Inject, Optional } from "@angular/core";
import { Configuration, BASE_PATH } from "shared/lib/v2/apis/programs";
import { ProgramService as ConvercusProgramService } from "shared/lib/v2/apis/programs/api/program.service";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { INTERACTION_ID } from "shared/lib/common/constants";
import { EnvironmentService } from "shared/lib/common/services";

@Injectable({ providedIn: "root" })
export class ProgramService extends ConvercusProgramService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration,
    protected environmentService: EnvironmentService,
  ) {
    super(httpClient, environmentService.getVariable("API_V2"), configuration);
  }

  public getInteractionPointsOfProgram(programId: string, interactionId: string = INTERACTION_ID, recursive?: boolean): Observable<any> {
    return super.getInteractionPointsOfProgram(interactionId, programId, recursive);
  }

  public getStore(partnerId: string, programId: string, storeId: string, interactionId: string = INTERACTION_ID): Observable<any> {
    return super.getStore(interactionId, partnerId, programId, storeId);
  }

  public getProgramConfig(programId: string): Observable<any> {
    if (programId === null || programId === undefined) {
      throw new Error("Required parameter programId was null or undefined when calling getProgramConfig.");
    }

    return this.httpClient.get(`${this.environmentService.getVariable("API_V2")}/public/programs/${programId}/config`, {
      headers: { "interaction-id": "posapp" },
    });
  }
}
